<template>
  <div style="display: flex">
    <auto-number-input
      v-model="innerValue"
      :precision="3"
      style="flex: 1"
      :disabled="disabled"
      :min="0"
      @change="onChange"
    />
    <span style="min-width: 50px;line-height: 28px;">M/T</span>
  </div>
</template>

<script>
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'

export default {
  name: 'SeChargeWeight',
  components: {
    AutoNumberInput
  },
  props: {
    value: { type: [String, Number], required: true },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      innerValue: Number(this.value) || 0
    }
  },
  watch: {
    value(value) {
      this.innerValue = Number(value) || 0
    }
  },
  methods: {
    onChange(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>
